import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { FiEye, FiEyeOff } from 'react-icons/fi';

type PasswordVisibilityToggleProps = {
  isVisible: boolean;
  onToggle: () => void;
  className?: string;
  inputId: string;
};

const PasswordVisibilityToggle: FC<PasswordVisibilityToggleProps> = ({
  isVisible,
  onToggle,
  className,
  inputId,
}) => {
  const { t } = useTranslation();

  return (
    <label
      htmlFor={inputId}
      onPointerDown={onToggle}
      aria-label={t(isVisible ? 'AuthLayout.hidePassword' : 'AuthLayout.showPassword')}
      className={classNames(
        'flex items-center justify-center text-[#748194] cursor-pointer',
        className,
      )}
    >
      {isVisible ? <FiEye size={16} /> : <FiEyeOff size={16} />}
    </label>
  );
};

export default PasswordVisibilityToggle;
